import { Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { OmpButtonPlacement, OmpMoment, OmpPage } from '../../../_models';
import {
  OmpControlButton,
  OmpControlButtons,
  OmpControlPlacementOptions,
  OmpPageBottomOrderField,
  ompControlKeys,
} from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-next-order-details-settings',
  templateUrl: './next-order-details-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: 0, paddingTop: '0', paddingBottom: '0', overflow: 'hidden' }),
        animate('200ms ease', style({ height: '*', opacity: 1, paddingTop: '*', paddingBottom: '*' })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('180ms ease', style({ height: '0', opacity: 0, paddingTop: '0', paddingBottom: '0' })),
      ]),
    ]),
  ],
})
export class OmpNextOrderDetailsSettingsComponent extends OmpSectionSettings {
  @Input() page: OmpPage;
  @Input() moment: OmpMoment;

  public placementOptions = OmpControlPlacementOptions;
  public openGroup = 'visibility';

  get isControlsVariant(): boolean {
    return this.controls.length > 0;
  }

  get isDetailsVariant(): boolean {
    return this.page === OmpPage.SubscriptionDetails || this.page === OmpPage.OrderDetails;
  }

  get controls(): OmpControlButton[] {
    const keys = ompControlKeys(this.page, this.moment).filter((key) => this.has(OmpControlButtons[key].toggle));
    return keys.map((key) => OmpControlButtons[key]);
  }

  get placeableControls(): OmpControlButton[] {
    return this.controls.filter((control) => control.placeable && this.has(control.placementField));
  }

  get bottomControls(): OmpControlButton[] {
    const saved = this.savedOrder();
    return this.placeableControls
      .filter((control) => this.value(control.placementField) === OmpButtonPlacement.PageBottom)
      .sort((a, b) => this.orderRank(saved, a) - this.orderRank(saved, b));
  }

  isGroupOpen(group: string): boolean {
    return this.openGroup === group;
  }

  toggleGroup(group: string) {
    this.openGroup = this.isGroupOpen(group) ? null : group;
  }

  moveBottomControl(control: OmpControlButton, offset: number) {
    const keys = this.bottomControls.map((entry) => entry.key);
    const from = keys.indexOf(control.key);
    const to = from + offset;
    if (from >= 0 && to >= 0 && to < keys.length) {
      keys.splice(to, 0, keys.splice(from, 1)[0]);
      this.set(OmpPageBottomOrderField, keys);
    }
  }

  isFirstAtBottom(control: OmpControlButton): boolean {
    return this.bottomControls.indexOf(control) === 0;
  }

  isLastAtBottom(control: OmpControlButton): boolean {
    const list = this.bottomControls;
    return list.indexOf(control) === list.length - 1;
  }

  has(field: string): boolean {
    return !!this.data && this.data[field] !== undefined;
  }

  value(field: string): any {
    return this.data ? this.data[field] : null;
  }

  private savedOrder(): string[] {
    const saved = this.data ? this.data[OmpPageBottomOrderField] : null;
    return Array.isArray(saved) ? saved : [];
  }

  private orderRank(saved: string[], control: OmpControlButton): number {
    const at = saved.indexOf(control.key);
    return at < 0 ? saved.length : at;
  }
}
